import SuggestionBadge from './SuggestionBadge';

export default SuggestionBadge;
